import {INavLink} from "modules/types";

export const navigationLinks: INavLink[] = [
	{
		title: "nav.picks",
		href: "/",
	},
	{
		title: "nav.leaderboard",
		href: "/leaderboard",
	},
];
